<template>
  <div>
    <CustomTemplateModal v-model="showCustomTemplateModal" />
    <CompleteProfileModal v-model="showCompleteProfileModal" />
    <CompleteProfileCTAModal v-model="showCompleteProfileCTAModal" />
    <!-- <WellcomeProModal v-model="showWellcomeProModal" /> -->
    <CompletedProfileModal v-model="showCompletedProfileModal" />
    <ResourceUseLimitModal
      v-if="!isProUser && isProfileCompleted"
      v-model="showResourceUseLimitModal"
    />
  </div>
</template>

<script setup>
import { useUserStore } from '@/stores/user'
import { useUserMetricsStore } from '@/stores/userMetrics'
import { useModalsStore } from '@/stores/modals'

const userStore = useUserStore()
const modalsStore = useModalsStore()
const userMetricsStore = useUserMetricsStore()
const handledPeriod = ref(null)

const { isProfileCompleted, isFreeUser, isProUser } = storeToRefs(userStore)
const {
  showCompleteProfileModal,
  showCustomTemplateModal,
  showCompleteProfileCTAModal,
  showResourceUseLimitModal,
  showWellcomeProModal,
  showedWellcomeProModal,
  showCompletedProfileModal,
} = storeToRefs(modalsStore)
const { resourceLimitModalType, hasConsultations } =
  storeToRefs(userMetricsStore)
const { yearMonth, isFirstAccessThisPeriod } = storeToRefs(userMetricsStore)

onMounted(() => {
  nextTick(() => {
    setTimeout(() => {
      if (
        !isProfileCompleted.value &&
        !isProUser.value
      ) {
        // Antes da 1ª consulta, exibe o CTA (com "lembrar mais tarde").
        // Após já ter consultas, força o modal de completar perfil.
        if (hasConsultations.value) {
          showCompleteProfileModal.value = true
        } else {
          showCompleteProfileCTAModal.value = true
        }
      }

    }, 2000)
  })
})

watch(
  [isFirstAccessThisPeriod, yearMonth, isProUser, isProfileCompleted],
  ([firstAccessThisPeriod, currentYearMonth, isCurrentUserPro, isCurrentProfileCompleted]) => {
    if (isCurrentUserPro || !isCurrentProfileCompleted) return
    if (!firstAccessThisPeriod || !currentYearMonth) return
    if (handledPeriod.value === currentYearMonth) return

    handledPeriod.value = currentYearMonth
    resourceLimitModalType.value = 'resoucesRestored'
    showResourceUseLimitModal.value = true
  },
  { immediate: true },
)
</script>

<style lang="scss" scoped></style>
